import buyOnlinePickupInstore from './buyOnlinePickupInstore';

export default buyOnlinePickupInstore;
